import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {Router} from "@angular/router";
import {HttpStatusCode} from "@angular/common/http";
import {UtilService, ResponseHttpError, ResponseHttpSuccess, CustomMessageService} from "library";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";

@Component({
  selector: 'app-validate-user',
  templateUrl: './validate-user.component.html'
})
export class ValidateUserComponent implements OnInit {
  loading: boolean = false;
  metadata!: any;
  status: number | null = null;
  intervalTime: number = 5000;
  delayStartTime: number = 2000;
  userInformation: any;
  @Input() mati: any;
  @Input() userId!: string;
  @Output() response = new EventEmitter();

  constructor(private router: Router,
              private utilService: UtilService,
              private authService: AuthService,
              private renderer: Renderer2,
              private customMessageService: CustomMessageService) { }

  ngOnInit() {
    this.metadata = {"solicitud_id": this.userId, "fixedLanguage":"es"}
    this.load();
  }

  load() {
    this.addMatiButton();


    // TODO quitar despues de las pruebas
    // this.checkStatus()
  }

  addMatiButton() {
    //  Agrega el elemento mati para el boton
    const container = this.renderer.createElement('metamap-button');
    this.renderer.setAttribute(container, 'id', 'mati-button');
    this.renderer.setAttribute(container, 'clientId', this.mati.client_id);
    this.renderer.setAttribute(container, 'flowId', this.mati.flow_id);
    this.renderer.setAttribute(container, 'color', 'red');
    this.renderer.setAttribute(container, 'metadata', JSON.stringify(this.metadata));
    this.renderer.appendChild(document.getElementById("mati-button-container"), container);

    //  Agrega el element script para la llamada al .js
    const containerScript = this.renderer.createElement('script');
    this.renderer.setProperty(containerScript, 'type', 'text/javascript');
    this.renderer.setProperty(containerScript, 'src', 'https://web-button.mati.io/button.js');
    this.renderer.appendChild(document.getElementById("mati-button-container"), containerScript);

    // @ts-ignore
    setTimeout(() => document.getElementById("mati-button").click(), 100);

    const metamapButton = document.querySelector('metamap-button');
    if(metamapButton !== null) {
      metamapButton.addEventListener('metamap:userFinishedSdk', (detail: any) => {
        console.log('finished payload', detail)
        setTimeout(() => this.checkStatus(), this.delayStartTime);
      });
      metamapButton.addEventListener('metamap:exitedSdk', (detail: any) => {
        console.log('exited payload', detail)
        this.response.emit({ status: 406 });
      });
    }
    this.utilService.disablePageLoading();
  }

  checkStatus() {
    this.authService.checkStatus(this.userId).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.PartialContent) {
          this.status = resp.status;
          setTimeout(() => this.checkStatus(), this.intervalTime);
        }else{
          this.status = resp.status;
          this.userInformation = resp.body.data;
          this.utilService.disablePageLoading();
          this.response.emit(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        this.response.emit(error);
      }
    });
  }

  onDataError() {
    this.response.emit({ status: HttpStatusCode.ResetContent });
  }

  confirm() {
    this.utilService.enablePageLoading();
    this.authService.confirmUserInformation(this.userId).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.NoContent) {
          this.response.emit(resp);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
          this.loading = this.utilService.disablePageLoading();
        }
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.BadRequest) {
          this.customMessageService.error('Usuario no encontrado. Por favor, vuelva a internarlo');
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.loading = this.utilService.disablePageLoading();
      }
    });
  }
}
